import {
  createRootRouteWithContext,
  Outlet,
  redirect,
  useLocation,
} from '@tanstack/react-router';
import { AlertsProvider } from '../providers/alerts';
import { useEffect } from 'react';
import { ReactTagManager } from 'react-gtm-ts';
import env from '../environment';
import { NotFound } from '../organisms/NotFound';
import { initAnalytics, trackPageView } from '../utility/analytics';

const GtmWrapper = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    if (env.gtm) {
      ReactTagManager.init({ code: env.gtm });
    }
  }, []);

  return <>{children}</>;
};

const AnalyticsWrapper = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageView();
  }, [location.pathname]);

  return <>{children}</>;
};

const RootComponent = () => (
  <GtmWrapper>
    <AnalyticsWrapper>
      <div className="text-white font-open h-screen w-screen overflow-hidden">
        <AlertsProvider>
          <Outlet />
        </AlertsProvider>
      </div>
    </AnalyticsWrapper>
  </GtmWrapper>
);

const openRoutes = ['/login', '/accept-invitation', '/register'];

const skippedRoutes = ['/logout', '/verify-email'];

export const Route = createRootRouteWithContext<{
  isAuthenticated: string | null;
}>()({
  component: RootComponent,
  beforeLoad: ({ location, context }) => {
    if (skippedRoutes.includes(location.pathname)) return;
    if (context.isAuthenticated) {
      if (openRoutes.includes(location.pathname)) {
        return redirect({
          to: '/',
        });
      }
    } else {
      if (!openRoutes.includes(location.pathname)) {
        return redirect({
          to: '/login',
        });
      }
    }
  },
  notFoundComponent: () => <NotFound />,
});
